import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_cfg_tax_code_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tax_country: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_code: fromDatatype.VarcharDatatypeInterface;
  tax_code_descr: fromDatatype.TextDatatypeInterface;
  tax_rate_txn: fromDatatype.NumericDatatypeInterface;
  tax_rate_filing: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  tax_tariff_code: fromDatatype.GuidDataFieldInterface;
  tax_industry_code: fromDatatype.GuidDataFieldInterface;
  is_input: boolean;
  is_output: boolean;
}

export class bl_fi_cfg_tax_code_RowClass
  implements bl_fi_cfg_tax_code_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tax_country: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_code: fromDatatype.VarcharDatatypeInterface;
  tax_code_descr: fromDatatype.TextDatatypeInterface;
  tax_rate_txn: fromDatatype.NumericDatatypeInterface;
  tax_rate_filing: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  tax_tariff_code: fromDatatype.GuidDataFieldInterface;
  tax_industry_code: fromDatatype.GuidDataFieldInterface;
  is_input: boolean;
  is_output: boolean;
}
